export const APP_NAME = 'Viventium';
export const APP_DESCRIPTION =
  'Stop relying on one AI for decisions that matter. Viventium keeps one main conversation, brings in specialized agents when they help, works with the OpenAI or Anthropic account you already have, and stays local-first and open source.';
export const APP_GITHUB_REPO_URL =
  'https://github.com/ProjectViventium/viventium';
export const APP_GITHUB_CHANGELOG_URL =
  'https://github.com/ProjectViventium/viventium/blob/main/CHANGELOG.md';
export const APP_DISCORD_INVITE_URL = 'https://discord.gg/HjVTvb7yr';
export const APP_CONTACT_EMAIL = 'helloviventium@gmail.com';
export const APP_INSTALL_SCRIPT_URL = 'https://www.viventium.ai/install.sh';
export const APP_INSTALL_SCRIPT_COMMAND =
  'curl -fsSL https://www.viventium.ai/install.sh | bash';
export const APP_INSTALL_FALLBACK_COMMAND =
  'git clone https://github.com/ProjectViventium/viventium.git && cd viventium && ./install.sh';
export const APP_ROADMAP_URL =
  'https://github.com/ProjectViventium/viventium/issues';
